import axios, { AxiosResponse } from "axios";
import Keycloak from "keycloak-js";
import { useSelector } from "react-redux";

// default keycloak values imported from environment
const keycloakDefaults = {
  keycloakUrl: import.meta.env.VITE_KEY_CLOAK_URL,
  keycloakClient: import.meta.env.VITE_KEY_CLOAK_CLIENT,
};

// initial options for the Keycloak instance.
// check Keycloak documentation for available options
export const initOptions = {
  onLoad: "check-sso",
  pkceMethod: "S256",
  checkLoginIframe: false,
};

// check if the realm exists in Keycloak
// used when creating a tenant to see check if the realm exists
// if it does, return OK, else return 404 not found.
export const checkRealmExists = async (realm: string) => {
  try {
    const response: Response = await fetch(
      `${keycloakDefaults.keycloakUrl}realms/${realm}`,
      {
        method: "GET",
      },
    );

    if (response.ok) {
      return true;
    }

    if (response.status === 404) {
      return false;
    }

    throw new Error("unexpected response status: " + response.status);
  } catch (error) {
    console.error("error checking realm existence:", error);
    return false;
  }
};

// set the Keycloak realm and return the Keycloak object for initialization.
export const SetKeycloakRealm = (realm: string) => {
  const initOptions = {
    url: keycloakDefaults.keycloakUrl,
    realm: realm,
    clientId: keycloakDefaults.keycloakClient,
  };

  const keycloak = new Keycloak(initOptions);

  return keycloak;
};
